import { render } from "./VisualShelf.vue?vue&type=template&id=60bf3ed8&scoped=true"
import script from "./VisualShelf.vue?vue&type=script&lang=js"
export * from "./VisualShelf.vue?vue&type=script&lang=js"

import "./VisualShelf.vue?vue&type=style&index=0&id=60bf3ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bf3ed8"]])

export default __exports__